import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRecordOn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			fill: "#FEF2F2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			stroke: "#FEE2E2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.4996,
			y: 16.4,
			width: .8,
			height: 8.2,
			fill: "#DC2626",
			stroke: "#DC2626",
			strokeWidth: .8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5992,
			y: 13.4,
			width: .8,
			height: 13.2,
			fill: "#DC2626",
			stroke: "#DC2626",
			strokeWidth: .8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.7008,
			y: 16.4,
			width: .8,
			height: 8.2,
			fill: "#DC2626",
			stroke: "#DC2626",
			strokeWidth: .8
		})
	]
});
const ForwardRef = forwardRef(SvgIconRecordOn);
export { ForwardRef as ReactComponent };
